#import "../fragments/booking-fragment.graphql"

mutation DeleteBooking($input: BookingDeleteInput!) {
    bookingDelete(input: $input) {
        booking {
            ...BookingFragment
        }
    }
}
